/**
 * @file
 * The popover shell, option rows and the show-more button.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { el, button, iconButton, colorDot, textSpan, setHidden, onClick } =
    berTags.dom;

  // Components: the popover's building blocks

  let popCount = 0;

  // Popover shell: header, crumb, scrolling body with the rows, footer.
  components.list = ({ label, items }) => {
    popCount += 1;
    const root = el('div', 'ber-tags__pop');
    root.id = `ber-tags-pop-${popCount}`;
    root.setAttribute('role', 'group');
    root.setAttribute('aria-label', label);

    const header = el('div', 'ber-tags__head');
    const crumb = el('div', 'ber-tags__crumb is-hidden');
    const body = el('div', 'ber-tags__list');
    const footer = el('div', 'ber-tags__foot');

    const itemsEl = items || el('div', 'ber-tags__optlist');
    body.appendChild(itemsEl);
    root.append(header, crumb, body, footer);

    return { el: root, header, crumb, body, items: itemsEl, footer };
  };

  // A list item shell from endpoint data: the datasets carry everything the
  // indexer and tooltips read. Content is built by listItemContent().
  components.listItem = (item) => {
    const row = el('div', 'ber-tags__opt');
    row.dataset.id = String(item.id);
    row.dataset.berCreated = String(item.created || 0);
    const datasets = {
      berColor: item.color,
      berText: item.text,
      berType: item.type,
      berBundle: item.bundle,
      berStatus: item.status,
      berDescription: item.description,
      berEditUrl: item.edit_url,
      berParents: item.parents,
      berParentIds: (item.parent_ids || []).map(String).join(' '),
    };
    Object.entries(datasets).forEach(([key, value]) => {
      if (value) {
        row.dataset[key] = value;
      }
    });
    const main = el('button', 'ber-tags__opt-main');
    main.type = 'button';
    main.textContent = item.label;
    row.appendChild(main);
    return row;
  };

  // Row content: dot, ancestry, title, badges, folder arrow. Returns refs.
  components.listItemContent = (row, meta) => {
    const main = row.querySelector('.ber-tags__opt-main');
    if (!main) {
      return {};
    }
    main.textContent = '';
    if (row.dataset.berColor) {
      main.appendChild(colorDot(row.dataset.berColor));
    }
    if (meta.parents !== '') {
      main.appendChild(textSpan('ber-tags__opt-parents', `${meta.parents} ›`));
    }
    const title = textSpan('ber-tags__opt-label', meta.label);
    main.appendChild(title);

    const labels = el('span', 'ber-tags__opt-labels');
    if (meta.type !== '') {
      labels.appendChild(textSpan('ber-tags__opt-type', meta.type));
    }
    const count = textSpan('ber-tags__opt-count is-hidden', '');
    count.setAttribute('aria-hidden', 'true');
    labels.appendChild(count);
    main.appendChild(labels);

    const arrow = iconButton(
      'ber-tags__opt-drill is-hidden',
      Drupal.t('Open @label', { '@label': meta.label }),
      'forward',
    );
    row.appendChild(arrow);

    return { main, title, labels, count, arrow };
  };

  // "Show N more" pagination button for options past the display limit.
  components.moreButton = ({ onMore }) => {
    const more = button('ber-tags__more ber-tags__more--reveal is-hidden');
    onClick(more, onMore);
    return {
      el: more,
      update: (count) => {
        more.textContent = Drupal.formatPlural(
          count,
          'Show 1 more',
          'Show @count more',
        );
        setHidden(more, count === 0);
      },
    };
  };
})(Drupal);
